export default __webpack_public_path__ + "static/media/excluir.42f6aecb.svg";